import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Step1Reflection from "./Steps/Step1Reflection";
import Step2Struggle from "./Steps/Step2Struggle";
import Step3Confidence from "./Steps/Step3Confidence";
import Step4CodiInsight from "./Steps/Step4CodiInsight";
import Step5Summary from "./Steps/Step5Summary";
import Step6Finish from "./Steps/Step6Finish";

const FeedbackModal = ({ isOpen, onClose, onSubmit }) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});

  const updateData = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const nextStep = () => setStep((prev) => Math.min(prev + 1, 6));
  const prevStep = () => setStep((prev) => Math.max(prev - 1, 1));

  const StepComponent = {
    1: Step1Reflection,
    2: Step2Struggle,
    3: Step3Confidence,
    4: Step4CodiInsight,
    5: Step5Summary,
    6: Step6Finish,
  }[step];

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
        >
          <motion.div
            key={step}
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: -10 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
          >
            {/* === Fixed Container for All Steps === */}
            <div className="w-96 h-96 bg-white rounded-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] p-6 overflow-hidden">
              <StepComponent
                data={formData}
                updateData={updateData}
                nextStep={nextStep}
                prevStep={prevStep}
                onClose={onClose}
                onSubmit={(feedbackData) => {
                  if (typeof onSubmit === "function") onSubmit(feedbackData);
                }}
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FeedbackModal;
